import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Button,
  Autocomplete,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InfiniteScroll from "react-infinite-scroll-component";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { completedFreights } from "../../../Services/Services";
import { useEffect } from "react";

export default function Completefreight() {
  const [data, setData] = useState([]);
  const [partyFilter, setPartyFilter] = useState("");
  const [tpFilter, setTpFilter] = useState("");
  const [truckFilter, setTruckFilter] = useState("");
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editRow, setEditRow] = useState({});
  const [editIndex, setEditIndex] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const limit = 50;
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const currentMonth = new Date().getMonth(); // 0 = Jan
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

const fetchCompletedFreights = async (pageNo = 1, filters = {}) => {
  const response = await completedFreights(pageNo, filters);
  const results = response?.results || [];

  if (pageNo === 1) {
    setData(results);
  } else {
    setData((prev) => [...prev, ...results]);
  }

  setHasMore(!!response.next);
};
 
  useEffect(() => {
  const handler = setTimeout(() => {
    setPage(1);
    fetchCompletedFreights(1, {
      party_name: partyFilter,
      tp_no: tpFilter,
      truck_no: truckFilter,
    });
  }, 500); // debounce 500ms

  return () => clearTimeout(handler);
}, [partyFilter, tpFilter, truckFilter]);

  const handleDelete = (index) => {
    const updatedData = data.filter((_, i) => i !== index);
    setData(updatedData);
  };

  const handleEditOpen = (row, index) => {
    setEditRow(row);
    setEditIndex(index);
    setEditDialogOpen(true);
  };

  const handleEditChange = (field, value) => {
    setEditRow({ ...editRow, [field]: value });
  };

  const handleEditSave = () => {
    const updated = [...data];
    updated[editIndex] = editRow;
    setData(updated);
    setEditDialogOpen(false);
  };

  const filteredData = data.filter((item) => {
    return (
      (partyFilter === "" ||
        item.party_name.toLowerCase().includes(partyFilter.toLowerCase())) &&
      (tpFilter === "" || item.tp_no.toString().includes(tpFilter)) &&
      (truckFilter === "" ||
        item.truck_no.toLowerCase().includes(truckFilter.toLowerCase()))
    );
  });

  /**
   * Handle export to Excel.
   * @function
   * @name handleExportExcel
   */
  const handleExportExcel = () => {
    // Get the table element
    const table = document.getElementById("freight-list");

    // Get all rows and create an array of arrays
    const rows = Array.from(table.querySelectorAll("tr"));
    const ws_data = [];

    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll("th, td"));
      const rowData = cells.map((cell) => cell.innerText.trim());
      if (rowData.length > 0) {
        ws_data.push(rowData);
      }
    });

    // Create a worksheet and add the data
    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    // Freeze the header row (optional, remove if not needed)
    // ✅ Freeze header row (optional, remove if not needed)
    ws["!freeze"] = { xSplit: 0, ySplit: 1 };

    // Auto-fit column widths
    // 🔸 Auto-fit column widths
    const colWidths = ws_data[0].map((_, colIndex) => {
      const maxLength = ws_data.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 10;
        return Math.max(max, len);
      }, 10);
      return { wch: maxLength + 2 };
    });
    ws["!cols"] = colWidths;

    // Define a black border style
    const blackBorder = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    // Style the header row
    // 🔸 Style header row
    const headerLength = ws_data[0].length;
    for (let c = 0; c < headerLength; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r: 0, c })];
      if (cell) {
        cell.s = {
          fill: { fgColor: { rgb: "FFFF99" } },
          font: { bold: true, color: { rgb: "000000" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: blackBorder,
        };
      }
    }

    // Style the data cells
    // 🔸 Style data cells
    for (let r = 1; r < ws_data.length; r++) {
      for (let c = 0; c < headerLength; c++) {
        const cell = ws[XLSX.utils.encode_cell({ r, c })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            border: blackBorder,
          };
        }
      }
    }

    // Create a workbook and add the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FreightList");

    // Create a blob from the workbook
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    // Save the blob as a file
    saveAs(data, "Freight_List.xlsx");
  };

  const handlePrintHTML = () => {
    const table = document.getElementById("freight-list");
    if (!table) return;

    const printContent = table.outerHTML;
    const printWindow = window.open("", "", "width=1000,height=600");

    printWindow.document.write(`
      <html>
        <head>
          <title>Freight List</title>
          <style>
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 12px;
            }
            th, td {
              border: 1px solid #999;
              padding: 4px;
              text-align: center;
            }
            th {
              background-color: #f2f2f2;
            }
            .no-print {
              display: none;
            }
          </style>
        </head>
        <body>
          <h3 style="text-align: center;">Freight List</h3>
          ${printContent}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }
  return (
    <div style={{ width: "100%", maxHeight: "calc(100vh - 70px)" }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mb: 2,
          py: 1,
          position: "sticky",
          top: 10,
          zIndex: 1000,
        }}
      >
 
        <TextField
          fullWidth
          label="Filter by Party Name"
          variant="outlined"
          size="small"
          value={partyFilter}
          onChange={(e) => setPartyFilter(e.target.value)}
          sx={{ flex: "1 1 150px",marginTop: -4 }}
        />
        <TextField
          fullWidth
          label="Filter by TP No"
          variant="outlined"
          size="small"
          value={tpFilter}
          onChange={(e) => setTpFilter(e.target.value)}
          sx={{ flex: "1 1 150px" ,marginTop: -4}}
        />
        <TextField
          fullWidth
          label="Filter by Truck No"
          variant="outlined"
          size="small"
          value={truckFilter}
          onChange={(e) => setTruckFilter(e.target.value)}
          sx={{ flex: "1 1 150px",marginTop: -4 }}
        />
        <Button
          variant="outlined"
          onClick={handleExportExcel}
          sx={{ minWidth: "40px", height: "40px", padding: 0,marginTop: -4 }}
        >
          <FileDownloadIcon fontSize="small" />
        </Button>
        <Button
          variant="outlined"
          onClick={handlePrintHTML}
          sx={{ minWidth: "40px", height: "40px", padding: 0,marginTop: -4 }}
        >
          <PrintIcon fontSize="small" />
        </Button>
      </Box>

 <InfiniteScroll
                dataLength={filteredData.length}
                next={() => {
                  const nextPage = page + 1;
                  setPage(nextPage);
                  fetchCompletedFreights(nextPage);
                }}
                hasMore={hasMore}
                // loader={
                //   <TableRow>
                //     <TableCell colSpan={40} align="center">
                //       Loading...
                //     </TableCell>
                //   </TableRow>
                // }
                scrollableTarget="scrollableDiv2"
                scrollThreshold={0.8}
                style={{ display: "contents" }}
              >

      <TableContainer
        id="scrollableDiv2"
        sx={{
          maxHeight: "75vh",
          overflow: "auto",
        }}
      >
          <Table
            stickyHeader
            size="small"
            id="freight-list"
            sx={{
              tableLayout: "auto",
              width: "auto",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "4px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableCell>SR. No</TableCell>
                <TableCell>Freight Id</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Branch Name</TableCell>
                <TableCell>Loading Date</TableCell>
                <TableCell>Unloading Date</TableCell>
                <TableCell>Truck No.</TableCell>
                <TableCell>D.O. No.</TableCell>
                <TableCell className="no-print">T.P. No.</TableCell>
                <TableCell>From</TableCell>
                <TableCell>To</TableCell>
                <TableCell>Loading Wt</TableCell>
                <TableCell>Receiving Wt</TableCell>
                <TableCell>Shortage Wt</TableCell>
                <TableCell>Billing Wt</TableCell>
                <TableCell>Freight Rate</TableCell>
                <TableCell>Freight Amt</TableCell>
                <TableCell className="no-print">TDS %</TableCell>
                <TableCell>TDS Amt</TableCell>
                <TableCell>Shortage Rate</TableCell>
                <TableCell>Shortage Amt</TableCell>
                <TableCell className="no-print">Ad Mines</TableCell>
                <TableCell className="no-print">Ad Diesel</TableCell>
                <TableCell className="no-print">Ad Cash</TableCell>
                <TableCell>Total Ad</TableCell>
                <TableCell>Commission</TableCell>
                <TableCell>Net Amt</TableCell>
                <TableCell>Others Exp.</TableCell>
                <TableCell>Net Payable</TableCell>
                <TableCell>Paid Amt</TableCell>
                <TableCell>Bal Amt</TableCell>
                <TableCell className="no-print">Truck Owner</TableCell>
                <TableCell className="no-print">Phone No.</TableCell>
                <TableCell className="no-print">PAN No.</TableCell>
                <TableCell className="no-print">Remark</TableCell>
                {/* Copy This To Every Freight Page */}
                <TableCell>Rec Amt</TableCell>
                <TableCell>Diff Amt</TableCell>
                <TableCell>Payment Remark</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={40} align="center">
                      No matching records found.
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: row.is_remember
                          ? "#ffe0b2"
                          : index % 2 === 0
                            ? "#fafafa"
                            : "#ffffff",
                        "& td": {
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.freight_id}</TableCell>
                      <TableCell>{row.party_name}</TableCell>
                      <TableCell>{row.branch_name}</TableCell>
                      <TableCell>{row.loading_date}</TableCell>
                      <TableCell>{row.unloading_date}</TableCell>
                      <TableCell>{row.truck_no}</TableCell>
                      <TableCell>{row.do_no}</TableCell>
                      <TableCell className="no-print">{row.tp_no}</TableCell>
                      <TableCell>{row.from_location}</TableCell>
                      <TableCell>{row.to_location}</TableCell>
                      <TableCell>{row.loading_wt}</TableCell>
                      <TableCell>{row.received_wt}</TableCell>
                      <TableCell>{row.shortage_wt}</TableCell>
                      <TableCell>{row.billing_wt}</TableCell>
                      <TableCell>{row.freight_rate}</TableCell>
                      <TableCell>{row.freight_amt}</TableCell>
                      <TableCell className="no-print">{row.tds_per}</TableCell>
                      <TableCell>{row.tds_amt}</TableCell>
                      <TableCell>{row.shortage_rate}</TableCell>
                      <TableCell>{row.shortage_amt}</TableCell>
                      <TableCell className="no-print">
                        {row.ad_mines_exp}
                      </TableCell>
                      <TableCell className="no-print">
                        {row.ad_diesel_exp}
                      </TableCell>
                      <TableCell className="no-print">
                        {row.ad_cash_exp}
                      </TableCell>
                      <TableCell>{row.total_advance}</TableCell>
                      <TableCell>{row.commission}</TableCell>
                      <TableCell>{row.net_amount}</TableCell>
                      <TableCell>{row.other_exp}</TableCell>
                      <TableCell>{row.net_payable}</TableCell>
                      <TableCell>{row.paid_amount.toFixed(1)}</TableCell>
                      <TableCell>{row.bal_amount.toFixed(1)}</TableCell>
                      <TableCell className="no-print">
                        {row.truck_owner}
                      </TableCell>
                      <TableCell className="no-print">{row.phone_no}</TableCell>
                      <TableCell className="no-print">{row.pan_no}</TableCell>
                      <TableCell className="no-print">{row.remark}</TableCell>
                      {/* This Need To Copy  */}
                      <TableCell className="no-print">


                        {(row.receive_amount).toFixed(1)}
                      </TableCell>
                      <TableCell className="no-print">
                        {(row.difference_amount).toFixed(1)}
                      </TableCell>
                      <TableCell className="no-print">
                        {row.payment_remark}
                      </TableCell>
                      <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    </TableRow>
                  ))
                )}
              {/* </InfiniteScroll> */}
            </TableBody>

            <TableRow
              sx={{
                backgroundColor: "#e3f2fd",
                fontWeight: "bold",
              }}
            >
              <TableCell colSpan={11} align="right">
                Total:
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.loading_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.received_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.shortage_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.billing_wt || 0),
                    0
                  )
                  .toFixed(3)}
              </TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.freight_amt || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center"></TableCell>

              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.tds_amt || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.shortage_amt || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center" colSpan={2}></TableCell>
              <TableCell align="center"></TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.total_advance || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.commission || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.net_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.other_exp || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.net_payable || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>

              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.paid_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>

              <TableCell align="center">
                {filteredData
                  .reduce(
                    (accumulator, currentValue) =>
                      accumulator + (+currentValue.bal_amount || 0),
                    0
                  )
                  .toFixed(1)}
              </TableCell>
              <TableCell align="center" colSpan={9}></TableCell>
            </TableRow>
          </Table>
      </TableContainer >
      </InfiniteScroll>

      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Freight Record</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <TextField
                label="Party Name"
                fullWidth
                value={editRow.party_name || ""}
                onChange={(e) => handleEditChange("party_name", e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Truck No"
                fullWidth
                value={editRow.truck_no || ""}
                onChange={(e) => handleEditChange("truck_no", e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="TP No"
                fullWidth
                value={editRow.tp_no || ""}
                onChange={(e) => handleEditChange("tp_no", e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="From"
                fullWidth
                value={editRow.from || ""}
                onChange={(e) => handleEditChange("from", e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="To"
                fullWidth
                value={editRow.to || ""}
                onChange={(e) => handleEditChange("to", e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Freight Amt"
                fullWidth
                value={editRow.freight_amt || ""}
                onChange={(e) =>
                  handleEditChange("freight_amt", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Net Payable"
                fullWidth
                value={editRow.net_payable || ""}
                onChange={(e) =>
                  handleEditChange("net_payable", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Remark"
                fullWidth
                value={editRow.remark || ""}
                onChange={(e) => handleEditChange("remark", e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleEditSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}
